import styled from 'styled-components';
import { rem } from 'polished';

const StyledWrapAutocomplete = styled.div`
  position: relative;
`;

const StyledAutoComplete = styled.input`
  line-height: 0;
  padding: ${rem('12px')};
  width: 100%;

  &:focus {
    border-color: ${props => props.theme.colors.secondary};
    outline: none;
  }

  ${props =>
    props.errorMessage &&
    `-webkit-text-fill-color:inherit;
    `};
`;

const StyledWrapList = styled.ul`
  background-color: ${props => props.theme.colors.grayLightest};
  border: 1px solid ${props => props.theme.colors.grayLight};
  margin: 0;
  padding: ${rem('15px')} ${rem('10px')};
  position: absolute;
  top: ${rem('40px')};
  z-index: 1;
`;

const StyleList = styled.li`
  color: ${props => props.theme.colors.grayDarkest};
  cursor: pointer;
  padding: 0 0 ${rem('20px')};
  font-size: ${props => props.theme.fontSize.small};
  :last-child {
    padding-bottom: 0;
  }
  :before {
    display: none;
  }
  :hover {
    color: ${props => props.theme.colors.primary};
  }
`;

export {
  StyledWrapAutocomplete,
  StyledAutoComplete,
  StyledWrapList,
  StyleList
};
